module.exports = __webpack_public_path__ + "img/imge15.426b6435.png";